"use strict";function presentWindow$(d){return ddSdk_1.ddSdk.invokeAPI(apiName,d)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.presentWindow$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.util.presentWindow";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"2.8.0"},_a[ddSdk_1.ENV_ENUM.android]={vs:"2.8.0"},_a)),exports.presentWindow$=presentWindow$,exports.default=presentWindow$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/util/presentWindow.js
// module id = 1018
// module chunks = 106